module.exports = __webpack_public_path__ + "static/media/Fabricio_Cunha_03.1f51a670.pdf";